import React from "react";

interface BottomNavbarButtonProps {
  onClick: () => void;
  label: string;
  icon: string;
  selected: boolean;
}

export const BottomNavbarButton = ({
  onClick,
  label,
  icon,
  selected,
}: BottomNavbarButtonProps) => (
  <button
    onClick={onClick}
    className={`
      flex flex-col w-20 items-center my-3 transition duration-200
      ${selected
        ? 'text-ptTeal'
        : 'text-gray-400 hover:text-gray-500 active:text-ptTeal'
      }
    `}>
    <i className={`fas ${icon} mb-2 `}/>
    <span className={`text-xs ${selected ? 'font-bold' : ''}`}>
      {label}
    </span>
  </button>
)
